import { render, staticRenderFns } from "./ModalSendMessage.vue?vue&type=template&id=43fda90a&scoped=true"
import script from "./ModalSendMessage.vue?vue&type=script&lang=js"
export * from "./ModalSendMessage.vue?vue&type=script&lang=js"
import style0 from "./ModalSendMessage.vue?vue&type=style&index=0&id=43fda90a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43fda90a",
  null
  
)

export default component.exports